<template>
  <v-navigation-drawer v-model="showHelp" app right width="400" stateless clipped>
    <v-card tile flat>
      <v-card-title class="text-body-2 primary white--text pt-1" :class="darkMode?'darken-4':'darken-1'">
        <v-btn color="white" icon @click="back()" :disabled="show === 0"><v-icon>mdi-arrow-left</v-icon></v-btn>
        <v-spacer/>
        <v-btn plain color="white" @click="show=0" :disabled="show === 0">View topics</v-btn>
        <v-spacer/>
        <v-btn color="white" icon @click="$emit('input',false)"><v-icon>mdi-close</v-icon></v-btn>
        <v-text-field outlined hide-details dense placeholder="Search..." v-model="search"
                      background-color="white"
                      prepend-inner-icon="mdi-magnify" clearable @keydown.enter="doSearch()" @click:clear="clear"/>
      </v-card-title>
      <v-divider/>

      <v-row v-show="show === 0" justify="start" class="pl-6 pt-6 ma-0 overflow-y" style="height:calc(100vh - 190px)">
        <v-card v-for="topic in topics" :key="topic.id" height="180" width="350" class="mb-6 mr-6 pa-3 text-center"
                @click="goToTopics(topic.id)">
          <v-icon class="green--text">{{topic.icon}}</v-icon>
          <div class="text-h6 my-4">{{topic.name}}</div>
          <div class="grey--text text--darken-1">{{topic.description}}</div>
          <v-footer absolute :color="darkMode?'grey darken-4':'white'" class='text-caption'>
            {{topic.articleCount}} article{{topic.articleCount===1?'':'s'}}
            <v-spacer/>
            <v-icon x-small class="mr-1">mdi-eye</v-icon>{{topic.readCount | number}}
          </v-footer>
        </v-card>
      </v-row>

      <div v-show="show === 1" class="pa-6">
        <div v-if="busy" class="text-center"><v-progress-circular indeterminate color="primary" size="50"/></div>
        <div v-else-if="didSearch && !results.length" class="text-center pt-16" style="height:calc(100vh - 238px)">No results found</div>
        <template v-else>
          <div class="text-h5">{{didSearch ? 'Search results' : topic.name}}</div>
          <v-btn-toggle borderless v-model="sortMethod" color="primary" @change="sort">
            <v-btn plain x-small>Most viewed</v-btn>
            <v-btn plain x-small>Most recent</v-btn>
          </v-btn-toggle>

          <v-list two-line outlined class="pa-0 mt-4 overflow-y" style="height:calc(100vh - 310px)">
            <template v-for="article in articles">
              <v-list-item :key="article.id" @click="goToArticle(article.id)">
                <v-list-item-content>
                  <v-list-item-title>{{article.name}}</v-list-item-title>
                  <v-list-item-subtitle>Updated {{article.updated | formatDate}}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action><div class="text-caption"><v-icon x-small class="mr-1">mdi-eye</v-icon>{{article.readCount | number}}</div></v-list-item-action>
              </v-list-item>
              <v-divider :key="'d'+article.id"/>
            </template>
          </v-list>
        </template>
      </div>

      <div v-show="show === 2" class="px-6 pb-6 overflow-y" style="height:calc(100vh - 190px)">
        <div ref="top"/>
        <div class="text-h4 mt-6">{{article.name}}</div>
        <div class="text-caption mb-6">{{article.updated | formatDate}}</div>

        <div v-html="article.text"/>
        <template v-if="article.seeAlso.length">
          <div class="text-h5 mt-6">See also</div>
          <v-hover v-for="seeAlso in article.seeAlso" :key="seeAlso.id" v-slot:default="{ hover }">
            <v-card :color="hover?'grey lighten-3':''"
                    width="400" outlined flat class="pa-3 mt-4 mr-4 font-weight-medium d-inline-block"
                    @click="goToArticle(seeAlso.id)">
              <v-icon color="primary" class="mr-2 mt-n1">mdi-information</v-icon>
              {{seeAlso.name}}
            </v-card>
          </v-hover>
        </template>
      </div>

      <v-divider/>
      <v-card-actions class="text-center">
        <v-spacer/>
        <v-btn x-small class="my-1" color="primary" @click="ticket={subject:'',text:''};showCreateTicket=true">Contact us</v-btn>
        <v-spacer/>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="showCreateTicket" persistent max-width="500">
      <v-card>
        <v-card-title>Contact us</v-card-title>
        <v-divider/>
          <v-form immediate ref="form" class="pa-5 pb-2">
            <v-text-field label="Subject" v-model="ticket.subject" outlined dense :rules="[fieldRules.required,fieldRules.maxLength(50)]"/>
            <v-textarea label="What do you need help with?" v-model="ticket.text" outlined dense rows="4"
                        :rules="[fieldRules.required,fieldRules.maxLength(1000)]"/>
          </v-form>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer></v-spacer>
          <v-btn plain color="primary" @click="showCreateTicket=false">Cancel</v-btn>
          <v-btn color="primary" @click="createTicket()">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'Help',
  props: {
    value: {type:Boolean, required:true},
    help: {type:Object, required:false}
  },
  data: () => ({
    showHelp: false,
    show: 0,
    topics: [],
    topic: {name:'',articles:[]},
    article: {name:'',seeAlso:[]},
    sortMethod: 0,
    search: '',
    busy: false,
    didSearch: false,
    results: [],
    showCreateTicket: false,
    ticket: {}
  }),
  computed: {
    articles() {
      return this.didSearch ? this.results : this.topic.articles;
    }
  },
  watch: {
    value() {
      this.showHelp = this.value;
      this.didSearch = false;
    },
    async help() {
      if (this.help) {
        this.search = '';
        await this.goToTopics(this.help.topicId);
        if (this.help.articleId)
          await this.goToArticle(this.help.articleId, this.help.ref);
      }
      else
        this.clear();
    }
  },
  async created() {
    const results = await this.$apiCall(`query Help {
                                            helpTopics {id,name,icon,description,articleCount,readCount}
                                          }`);
    if (!results.error)
      this.topics = results.data.helpTopics;
  },
  methods: {
    clear() {
      this.results = [];
      this.didSearch = false;
      this.show = 0;
    },
    async doSearch() {
      this.busy = true;
      this.didSearch = true;
      this.show = 1;
      if (!this.search.trim()) {
        this.results = [];
        return;
      }
      const results = await this.$apiCall(`query Help($text:String!) {
                                              search(text:$text) {name,id,updated,readCount,topicName}
                                            }`, {text:this.search.trim()});
      this.busy = false;
      if (!results.error) {
        this.results = results.data.search;
        this.sortMethod = -1;
      }
    },
    async goToTopics(id) {
      const results = await this.$apiCall(`query Help($id:ID!) {
                                              helpTopic(id:$id,read:true) {id,name,articles{id,name,updated,readCount}}
                                            }`, {id});
      if (!results.error) {
        this.topic = results.data.helpTopic;
        this.sort();
        this.show = 1;
      }
    },
    async goToArticle(id, ref) {
      const results = await this.$apiCall(`query Help($id:ID!) {
                                              helpArticle(id:$id,read:true) {name,updated,text,seeAlso{id,name}}
                                            }`, {id});
      if (!results.error) {
        this.article = results.data.helpArticle;
        if (this.didSearch) {
          this.article.text = this.article.text.replace(new RegExp(this.search,'gi'), `<span id="firstresult" class="yellow">${this.search}</span>`);
          ref = 'firstresult';
        }
        this.showArticle = true;
        this.show = 2;
        if (ref) {
          this.$nextTick(() => {
            const element = document.getElementById(ref);
            if (element)
              element.scrollIntoView();
          });
        }
        else
          this.$nextTick(() => {this.$refs.top.scrollIntoView();});
      }
    },
    back() {
      if (this.show)
        this.show--;
      if (this.show === 0) {
        this.search = '';
        this.clear();
      }
    },
    sort() {
      if (this.sortMethod === -1)
        this.sortMethod = 0;
      const list = this.didSearch ? this.results : this.topic.articles;
      list.sort((a,b) => {
        if (this.sortMethod === 1) { // Most recent
          if (a.updated > b.updated)
            return -1;
          if (a.updated < b.updated)
            return 1;
          return 0;
        }
        else {  // Most viewed
          if (a.readCount > b.readCount)
            return -1;
          if (a.readCount < b.readCount)
            return 1;
          return 0;
        }
      });
    },
    async createTicket() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }

      const results = await this.$apiCall(`mutation Help($input:HelpTicketInput!) {
                                              helpTicketCreate(input:$input)
                                            }`, {input:this.ticket});
      if (!results.error) {
        this.showCreateTicket = false;
        this.$store.commit('setError', {type:'success',message:`We received your request and will get back to you shortly.`});
      }
    }
  }
}
</script>
